<template>
  <div class="best-card">
    <span class="match-banner">Best match</span>

    <a
      :href="dealUrl"
      class="image-container"
    >
      <v-lazy-image
        class="product-image pin-image-top"
        :class="{ 'has-banner': hasBanner(deal),
                  'last-call-margin': isLimitedTimeSale(deal),
        }"
        :src="`${deal.media_url}?width=450&height=300&aspect_ratio=3:2`"
        :src-placeholder="lazyPlaceholderImage"
        :alt="deal.public_name"
      />
      <DealBanner
        class="product-card-deal-banner"
        :deal="deal"
        :is-black-friday-last-call="isBlackFridayLastCall(deal)"
        :is-last-call="isLastCall(deal)"
        :is-limited-time-sale="isLimitedTimeSale(deal)"
      />
      <SumoDayBadge v-if="isSumoDay(deal)" class="campaign-badge sumo-day-badge" />
      <BlackFridayBadge
        v-if="isBlackFriday(deal) || isBlackFridayLastCall(deal)"
        class="campaign-badge black-friday-badge"
      />
    </a>

    <div class="details-container">
      <span class="match-banner">Best match</span>

      <a
        class="section-title d-block mt-3"
        :href="dealUrl"
      >
        {{ deal.public_name }}
      </a>

      <p class="d-block deal-description my-0">
        {{ deal.card_description }}
      </p>

      <DealRating
        class="my-2"
        is-deal-card
        :deal="deal"
      />

      <deal-price
        class="product-carousel-component"
        :price="deal.price"
        :original-price="deal.original_price"
        :is-free="deal.is_free"
      />

      <div class="link-container">
        <div class="buy">
          <a
            :href="dealUrl"
          >
            View details
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DEAL_PLACEHOLDER_IMG } from '@/constants/global';
import get from 'lodash/get';
import VLazyImage from 'v-lazy-image';
import BlackFridayBadge from '~/static/campaigns/black-friday-badge.svg?inline';
import SumoDayBadge from '~/static/sumoday-badge.svg?inline';
import DealBanner from '../utilities/DealBanner.vue';
import DealRating from '../utilities/DealRating.vue';
import CampaignsMixin from '~/mixins/campaigns';
import DealPrice from '../common/DealPrice.vue';

export default {
  components: {
    BlackFridayBadge,
    DealBanner,
    DealRating,
    SumoDayBadge,
    VLazyImage,
    DealPrice,
  },
  mixins: [CampaignsMixin],
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lazyPlaceholderImage() {
      return DEAL_PLACEHOLDER_IMG;
    },
    dealUrl() {
      return `${this.deal.get_absolute_url}?ref=best-match`;
    },
  },
  methods: {
    onClickTile(isNewWindow = false) {
      if (isNewWindow) {
        window.open(this.deal.get_absolute_url);
      } else {
        window.location = this.deal.get_absolute_url;
      }
    },
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.campaign-badge {
  position: absolute;

  &.sumo-day-badge {
    width: 108px;
    height: 30px;
    top: 8px;
    right: 0;
  }

  &.black-friday-badge {
    width: 115px;
    height: 32px;
    top: 8px;
    right: 8px;
  }
}

.best-card {
  background: #f5f5f9;
  border-radius: 4px;
  padding: 16px;
  position: relative;
  margin-bottom: 24px;
}

.stretched-link {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  font-size: 0;
}

.image-container {
  min-width: 270px;
  width: 100%;
  height: auto;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  border: 1px solid #dadde5;
  border-bottom: 0;
  background-color: #fff;
  display: block;

  .has-banner {
    margin-top: -31px;
  }

  .last-call-margin {
    margin-top: -29px;
  }
}

.product-card-deal-banner {
  border-radius: 0;
  width: 100%;
  position: initial;
}

.product-image {
  min-height: 180px;
  width: 100%;
}

.section-title {
  color: #021414;
  cursor: pointer;
  display: inline-block;
  font-size: 19px;
  font-weight: 600;
  line-height: 1.5;
  max-width: 100%;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: normal;
}

.section-title:hover,
.section-title:focus {
  color: #021414;
}

.deal-description {
  color: #434d59;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* stylelint-disable-next-line */
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  /* stylelint-disable-next-line */
  -webkit-box-orient: vertical;
}

.match-banner {
  padding: 4px 8px;
  display: inline-block;
  color: #fff;
  background: #0e6ef4;
  font-family: Roboto, serif;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  border-radius: 4px;
  margin-bottom: 8px;
}

.details-container .match-banner {
  display: none;
}

.link-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 16px;
}

.buy {
  margin-right: 16px;
}

.buy a {
  background: #ffbc00;
  border-radius: 40px;
  color: #1b1b1b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 16px 40px;
  text-decoration: none;
}

.view {
  font-family: Roboto, serif;
  color: #0e6ef4;
  font-size: 16px;
  line-height: 24px;
  text-decoration: none;
  cursor: pointer;
}

.view:hover {
  text-decoration: underline;
}

@include media-breakpoint-up(lg) {
  .best-card {
    display: flex;
    flex-direction: row;
    padding: 24px 32px;
    position: relative;
  }

  .best-card::before {
    content: '';
    position: absolute;
    background-image: url(~/static/best-result-blob.svg);
    background-repeat: no-repeat;
    background-position: right 16px center;
    background-size: contain;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.5;
    pointer-events: none;
  }

  .image-container {
    order: 2;
    max-width: 350px;
    align-self: center;
  }

  .details-container {
    order: 1;
    flex-grow: 1;
    margin-right: 16px;
  }

  .details-container .match-banner {
    display: inline-block;
  }

  .best-card > .match-banner {
    display: none;
  }
}

</style>
